import React, { useMemo, useState } from 'react';
import { ApiRequest } from '@/utils/axios';
import { notify } from '@/utils/notify';
import { modalStore } from '@/stores/modal.store';
import SuccessIcon from '@/components/Notifications/SuccessIcon';
import AlertIcon from '@/components/Notifications/AlertIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import { IBaseItem } from '@/utils/types/Items';
import AdminSkinPicker from '@/components/Modals/AdminAddBet/AdminSkinPicker';
import AdminBotPicker from '@/components/Modals/AdminAddBet/AdminBotPicker';

const AdminAddBet = () => {
    const { toggleModal, setData } = modalStore((s) => s);
    const [selected, setSelected] = useState<IBaseItem[]>([]);
    const [botUserId, setBotUserId] = useState<number | null>(null);
    const [submitting, setSubmitting] = useState(false);

    const total = useMemo(
        () => selected.reduce((acc, it) => acc + it.priceUsd, 0),
        [selected]
    );

    async function submit() {
        if (selected.length === 0) {
            notify('error', <AlertIcon />, <NotifyWrapper title="Error" text="Pick at least one skin" />);
            return;
        }
        setSubmitting(true);
        try {
            const { data } = await ApiRequest.post('/admin/jackpot/bet', {
                itemIds: selected.map((i) => Number(i.id)),
                ...(botUserId ? { userId: botUserId } : {}),
            });
            if (data?.success) {
                notify(
                    'success',
                    <SuccessIcon />,
                    <NotifyWrapper title="Success" text="Bet was added to jackpot" />
                );
                toggleModal(false);
                setData({});
            } else {
                notify('error', <AlertIcon />, <NotifyWrapper title="Error" text="Failed to add bet" />);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="flex flex-col gap-4 min-w-[640px] max-md:min-w-0">
            <AdminBotPicker value={botUserId} onChange={setBotUserId} label="Bot (bet from)" />
            <AdminSkinPicker selected={selected} setSelected={setSelected} />

            <div className="flex items-center justify-between gap-3 pt-2 border-t border-stroke">
                <div className="text-[12px] text-text_3">
                    Selected:{' '}
                    <b className="text-text_main tabular-nums">{selected.length}</b>{' '}
                    <span className="mx-2 text-text_4">|</span>
                    Value:{' '}
                    <b className="text-accent_5 tabular-nums">${total.toFixed(2)}</b>
                </div>
                <button
                    type="button"
                    onClick={submit}
                    disabled={submitting || selected.length === 0}
                    className="px-5 py-2.5 rounded-fl text-[12.5px] font-bold tracking-[0.06em] text-white disabled:opacity-50 disabled:cursor-not-allowed hover:brightness-110 transition-all"
                    style={{
                        background: 'linear-gradient(180deg, #ff7d6e, #f04e3a)',
                        boxShadow:
                            '0 8px 20px rgba(240,78,58,0.35), inset 0 1px 0 rgba(255,255,255,0.25)',
                    }}
                >
                    {submitting ? 'Adding…' : 'ADD BET'}
                </button>
            </div>
        </div>
    );
};

export default AdminAddBet;
